import React, { useMemo } from 'react';
import { useCompany } from '@src/@data/store/CompanyProvider';
import { useFormatters } from '@hooks/useFormatters';
import { useMessages } from '@hooks/useMessages';

interface Props {
  className?: string;
}

const NavCompanyCredit: React.FC<Props> = ({ className = '' }) => {
  const { messages } = useMessages();
  const { selectedCompany } = useCompany();
  const { moneyFormatter } = useFormatters();

  const credit = useMemo<string | undefined>(() => {
    if (!selectedCompany?.companyCredit) {
      return undefined;
    }
    const currency = selectedCompany.settings.currency;
    return moneyFormatter.format(selectedCompany.companyCredit, {
      fromCents: true,
      currency,
    });
  }, [moneyFormatter, selectedCompany]);

  if (!credit) return null;

  return (
    <li className={className}>
      <div className="d-flex align-items-center">
        <h5 className="ml-50 mb-0 selected-language">
          {messages('company_available_credit')}
        </h5>
        <h5 className="ml-50 mb-0">{credit}</h5>
      </div>
    </li>
  );
};

export default NavCompanyCredit;
